import React from 'react'

import { translate } from '../../../../utils/translation'
import { palette } from '../../../../styles/variables'

import {
  AppBannerBlackFridayText,
  AppBannerOfferText,
  AppBannerTextWrapperStyled,
  AppBannerTextStyled,
  AppBannerTextContainer,
  AppBannerTextDivider,
  AppBannerVerticalText,
  AppBannerInfoTextProps,
} from './styled'
import { AppBannerFlagFly } from './AppBannerFlagFly'

export const AppBannerText = ({ theme }) => {
  const { flagText, showFlagFly, verticalText } = theme
  return (
    <AppBannerTextStyled>
      <AppBannerTextWrapperStyled>
        {verticalText && (
          <AppBannerVerticalText>
            {translate(verticalText)}
          </AppBannerVerticalText>
        )}
        <AppBannerTextContainer>
          <div
            style={{
              display: 'inline-flex',
              flexDirection: 'row',
              width: '100%',
              height: '100%',
              justifyContent: 'flex-start',
              alignItems: 'center',
            }}
          >
            {showFlagFly && <AppBannerFlagFly />}
            <AppBannerBlackFridayText theme={theme}>
              {translate(flagText)}
            </AppBannerBlackFridayText>
            {showFlagFly && <AppBannerFlagFly flip />}
          </div>
          <AppBannerOfferText theme={theme}>
            {translate('bf_banner_offer')}
          </AppBannerOfferText>
        </AppBannerTextContainer>
      </AppBannerTextWrapperStyled>
      <AppBannerTextDivider theme={theme} />
      <AppBannerInfoTextProps
        theme={theme}
        fontSize="16px"
        lineHeight="20px"
        color={palette.white}
        dangerouslySetInnerHTML={{
          __html: translate(theme.textBanner),
        }}
      />
    </AppBannerTextStyled>
  )
}
